import {Injectable, ViewChild} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, tap} from "rxjs";
import {TableComponent} from "../../shared/components/table/table.component";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
  providedIn: 'root'
})
export class ListService {
  constructor(private http: HttpClient) { }

  /**
   * obtener los servicios registrados
   */
  getPersonalData(data:any):Observable<any>{
    const action = (data.type == 'employee') ? 'employee/getpersonaldata':'client/getpersonaldata';
    const body = JSON.stringify(data);
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        //`${END_POINT}/client/getpersonaldata`,
        `${END_POINT}/`+action,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  };

  /**
   * Function: This method is a post call to backend
   */
  updateStatus(data:any):Observable<any>{
    const body = JSON.stringify({form:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/assignments/updatestatus`,
        body,
        { headers }
    ).pipe(
        tap(() =>{
          this.controlLoader(false);
        })
    )
  }

  /**
   * Consulta para obtener la ubicación actual de una asignación
   */
  getLocation(data: any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);

    return this.http.post<any>(
        `${END_POINT}/assignments/getlocation`, // Ajusta este endpoint
        body,
        { headers }
    );
  }

  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    //let elemet: any = document.getElementsByClassName("loader-screen")[0];
    //elemet.style.opacity = 0.8;
    //elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }
}
